import {handleValidationChange} from '../CommonValidation';

export const validateForwarders= (data, setIsError) => {

    var isValid = true;
    var isValidName = true;
    var isValidAddress = true;
    var isValidPhoneNumber = true;


    if(data.address === "") {
        handleValidationChange("address", true, setIsError);
        isValidAddress = false;
    } else {
        handleValidationChange("address", false, setIsError);
        isValidAddress = true;
    }

    
   if(data.name === "") {
        handleValidationChange("name", true, setIsError);
        isValidName = false;
    } else {
        handleValidationChange("name", false, setIsError);
        isValidName = true;
    }


    if(data.phone_number === "") {
        handleValidationChange("phone_number", true, setIsError);
        isValidPhoneNumber = false;
    } else {
        handleValidationChange("phone_number", false, setIsError);
        isValidPhoneNumber = true;
    }

    



    isValid = isValidName   && isValidPhoneNumber && isValidAddress



    return isValid
  
}

export const validateDepartment = (data, setIsError) => {

    var isValid = true;

   if(data.name === "") {
        handleValidationChange("name", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("name", false, setIsError);
        isValid = true;
    }

    return isValid
  
}

export const validateCustomer = (data, setIsError) => {

    var isValid = true;

   if(data.trade_name === "" || data.trade_name === undefined) {
        handleValidationChange("trade_name", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("trade_name", false, setIsError);
        isValid = true;
    }

   if(data.credit_limit === "" || data.credit_limit === undefined) {
        handleValidationChange("credit_limit", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("credit_limit", false, setIsError);
        isValid = true;
    }

   if(data.trade_address === "" || data.trade_address === undefined) {
        handleValidationChange("trade_address", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("trade_address", false, setIsError);
        isValid = true;
    }
    
   if(data.terms === "" || data.terms === undefined) {
        handleValidationChange("terms", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("terms", false, setIsError);
        isValid = true;
    }

   if(data.vat_type === "" || data.vat_type === undefined) {
        handleValidationChange("vat_type", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("vat_type", false, setIsError);
        isValid = true;
    }


    return isValid
  
}